import Box from '@mui/material/Box'
import List from '@mui/material/List'
import ListSubheader from '@mui/material/ListSubheader'
import Typography from '@mui/material/Typography'
import {
  NavItem,
  SecondaryListItems,
  useNavItems,
  useRecentItems,
} from './Layout/NavItems'

const Section = ({ title, items }) =>
  items.length > 0 && (
    <List
      subheader={
        <ListSubheader sx={{ bgcolor: 'transparent', lineHeight: '36px' }}>
          {title}
        </ListSubheader>
      }
    >
      {items.map((item) => (
        <NavItem key={item.path} {...item} />
      ))}
    </List>
  )

// A phone tab bar's More (Layout/TabBar.js): the pages visited last that the
// tabs leave out, then every page as the drawer lists them, the tabs' own
// included, then the rarely used ones the drawer tucks behind its chevron,
// then the environment, theme and settings at its foot.
const More = () => {
  const { items, moreItems } = useNavItems()
  const recent = useRecentItems()

  return (
    <Box sx={{ width: '100%', maxWidth: 600, mx: 'auto', pt: 3, pb: 2 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, px: 2, pb: 1 }}>
        More
      </Typography>
      <Section title="Recent" items={recent} />
      <Section title="Pages" items={items} />
      <Section title="Less used" items={moreItems} />
      <SecondaryListItems />
    </Box>
  )
}

export default More
